import React from "react";

import BASELoading from "../../../../../../../@BASE/core/BASELoading";
import BASESvgIcon from "../../../../../../../@BASE/core/BASESvgIcon";
import NavLinkAdapter from "../../../../../../../@BASE/core/NavLinkAdapter";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Instructions from "../components/Instructions";

export default function PEBrief(props) {
  const { data, dir, ins, course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>
      <style>
        {`
          .wysiwyg p {
            margin: 0px;
          }
        `}
      </style>

      <Instructions ins={ins} course={course} dir={dir} tl={tl} componentCommentsCount={componentCommentsCount} noInstructions />

      {data.core.map((scenario, index) => {
        return (
          <React.Fragment key={index}>
            <Paper
              elevation={0}
              variant="outlined"
              square
              className="w-100 p-16 m-16"
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box className="flex items-center w-full">
                    <Typography className="text-14 font-bold grow">
                      {scenario.difficulty !== "single"
                        ? scenario.difficulty.charAt(0).toUpperCase() +
                          scenario.difficulty.slice(1).toLowerCase() +
                          " Level"
                        : ""}{" "}
                      Scenario
                    </Typography>
                    <Chip
                      icon={
                        <BASESvgIcon size={20}>
                          heroicons-outline:chat
                        </BASESvgIcon>
                      }
                      label={componentCommentsCount(scenario.id)}
                      variant="outlined"
                      className="mx-16"
                    />
                    <Button
                      variant="outlined"
                      color="primary"
                      component={NavLinkAdapter}
                      to={`comments/new/edit?c=${scenario.id}&t=${scenario.difficulty} level scenario`}
                      startIcon={
                        <BASESvgIcon size={20}>
                          heroicons-outline:plus
                        </BASESvgIcon>
                      }
                      size="small"
                    >
                      Add
                    </Button>
                  </Box>
                  <Divider className="my-16" />
                </Grid>
                {scenario.description && (
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography className="text-14 m-0">
                          {scenario.description}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                
                {scenario.transcript && (
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Typography
                          className={`${tl} m-0`}
                          dir={dir}
                        >
                          {scenario.transcript}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              {scenario.segments && (
                <>
                  <Typography className="text-14 font-bold m-0 mt-24">
                    Video Segments:
                  </Typography>
                  <Divider className="my-16" />
                  {scenario.segments.map((segment, index) => (
                    <Paper
                      elevation={0}
                      variant="outlined"
                      square
                      className="p-16 my-16"
                      key={index}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Box className="flex items-center w-full">
                            <Typography className="text-16 font-bold grow">
                              Segment {index + 1}:
                            </Typography>
                            <Chip
                              icon={
                                <BASESvgIcon size={20}>
                                  heroicons-outline:chat
                                </BASESvgIcon>
                              }
                              label={componentCommentsCount(segment.id)}
                              variant="outlined"
                              className="mx-16"
                            />
                            <Button
                              variant="outlined"
                              color="primary"
                              component={NavLinkAdapter}
                              to={`comments/new/edit?c=${segment.id}&t=${
                                scenario.difficulty
                              }: Segment ${index + 1}`}
                              startIcon={
                                <BASESvgIcon size={20}>
                                  heroicons-outline:plus
                                </BASESvgIcon>
                              }
                              size="small"
                            >
                              Add
                            </Button>
                          </Box>
                          <Divider className="my-16" />
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} lg={2}>
                              <Typography className="text-14 font-semibold m-0">
                                Narration:
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} lg={10}>
                              <Typography
                                className={`${tl} m-0 whitespace-pre-wrap`}
                                dir={dir}
                              >
                                {segment.text_tl}
                              </Typography>
                            </Grid>
                            {/* <Grid item xs={12} sm={4} lg={2}>
                              <Typography className="text-14 font-semibold m-0">
                                English Narration:
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} lg={10}>
                              <Typography className="text-14 m-0 whitespace-pre-wrap">
                                {segment.text_en}
                              </Typography>
                            </Grid> */}
                            <Grid item xs={12} sm={4} lg={2}>
                              <Typography className="text-14 font-semibold m-0">
                                Segment Time
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={8} lg={10}>
                              <Typography className="text-14 m-0 whitespace-pre-wrap">
                                {segment.start_minute}:
                                {segment.start_second < 10 ? `0${segment.start_second}` : segment.start_second} -
                                {segment.end_minute}:
                                {segment.end_second < 10 ? `0${segment.end_second}`: segment.end_second}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  ))}
                </>
              )}
            </Paper>
          </React.Fragment>
        );
      })}
    </div>
  );
}
